(function () {
  'use strict';

  var COMPANY_ID = 'TGmNaL';
  var LIST_ID = 'Rz6kmk';
  var REVISION = '2026-07-15';
  var PDFS = {
    freeze: 'https://cdn.shopify.com/s/files/1/0815/5450/5983/t/2/assets/home-freeze-dryer-sizing-checklist.pdf?v=1787692091',
    water: 'https://cdn.shopify.com/s/files/1/0815/5450/5983/t/2/assets/whole-house-water-system-sizing-checklist.pdf?v=1787692092'
  };

  function css() {
    if (document.getElementById('hh-klaviyo-capture-css')) return;
    var style = document.createElement('style');
    style.id = 'hh-klaviyo-capture-css';
    style.textContent = '' +
      '.hh-capture{margin:28px 0;padding:22px;border:1px solid #ead7c1;border-radius:10px;background:#fff8f1;color:#242424}' +
      '.hh-capture h2,.hh-capture h3{margin-top:0;margin-bottom:8px}' +
      '.hh-capture p{margin:0 0 12px}' +
      '.hh-capture__row{display:flex;gap:10px;flex-wrap:wrap;margin-top:12px}' +
      '.hh-capture input[type=email],.hh-capture input[type=text]{min-width:220px;flex:1;padding:12px;border:1px solid #cfc4b8;border-radius:6px;font-size:16px}' +
      '.hh-capture button{padding:12px 16px;border:0;border-radius:6px;background:#e87722;color:#fff;font-weight:700;cursor:pointer}' +
      '.hh-capture button[disabled]{opacity:.65;cursor:wait}' +
      '.hh-capture__fine{font-size:13px;color:#666;margin-top:8px}' +
      '.hh-capture__status{font-size:14px;margin-top:10px;font-weight:600}' +
      '.hh-footer-capture{max-width:420px;margin:0}' +
      '.hh-exit{position:fixed;inset:0;z-index:999999;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.45);padding:20px}' +
      '.hh-exit.is-open{display:flex}' +
      '.hh-exit__panel{max-width:520px;background:#fff;border-radius:12px;padding:26px;box-shadow:0 20px 60px rgba(0,0,0,.28);position:relative}' +
      '.hh-exit__close{position:absolute;right:12px;top:10px;background:transparent!important;color:#333!important;font-size:26px;line-height:1;padding:4px 8px}' +
      '@media(max-width:640px){.hh-capture{padding:18px}.hh-capture__row{display:block}.hh-capture input,.hh-capture button{width:100%;margin:0 0 10px}.hh-exit__panel{padding:22px 18px}}';
    document.head.appendChild(style);
  }

  function payload(email, firstName, props, source) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source || props.lead_source || 'Homestead Heavy signup form',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName || undefined,
                properties: props,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: LIST_ID } }
        }
      }
    };
  }

  function bindForm(form) {
    if (!form || form.dataset.hhBound === '1') return;
    form.dataset.hhBound = '1';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = (form.querySelector('input[type="email"]') || {}).value || '';
      var firstName = (form.querySelector('input[name="first_name"]') || {}).value || '';
      var button = form.querySelector('button[type="submit"]');
      var status = form.querySelector('.hh-capture__status');
      var props = {
        lead_source: form.dataset.leadSource || 'hh_capture_form',
        lead_magnet: form.dataset.leadMagnet || 'field_notes',
        signup_url: window.location.href
      };
      if (form.dataset.interest) props[form.dataset.interest] = true;
      if (!email || email.indexOf('@') === -1) {
        if (status) status.textContent = 'Enter a valid email address.';
        return;
      }
      if (button) { button.disabled = true; button.textContent = 'Sending...'; }
      if (status) status.textContent = '';
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(COMPANY_ID), {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', 'revision': REVISION },
        body: JSON.stringify(payload(email, firstName, props, form.dataset.customSource))
      }).then(function (res) {
        if (!res.ok && res.status !== 202) throw new Error('Klaviyo returned ' + res.status);
        form.reset();
        var url = form.dataset.downloadUrl || '';
        if (status) {
          status.innerHTML = url ? 'You are in. <a href="' + url + '" target="_blank" rel="noopener">Download your guide here</a> and check your inbox.' : 'You are in. Watch your inbox for the first field note.';
        }
        if (url && form.dataset.autoOpen === '1') window.open(url, '_blank', 'noopener');
      }).catch(function () {
        if (status) status.textContent = 'Something went wrong. Email sales@homesteadheavy.com and we will send it manually.';
      }).finally(function () {
        if (button) { button.disabled = false; button.textContent = button.dataset.label || 'Submit'; }
      });
    });
  }

  function formHtml(kind) {
    var data = {
      footer: {
        cls: 'hh-footer-capture', h: 'Get the Homestead Heavy Field Notes',
        p: 'Practical buying guides for backup power, clean water, food preservation, and off-grid equipment. No fluff. Just useful notes for building a more resilient property.',
        cta: 'Get Field Notes', source: 'footer_field_notes', magnet: 'field_notes', interest: 'interest_general', url: ''
      },
      exit: {
        cls: '', h: 'Leaving before you choose?',
        p: 'Get practical buyer notes on backup power, water systems, food preservation, and off-grid equipment before you spend serious money.',
        cta: 'Send Me the Field Notes', source: 'exit_intent_field_notes', magnet: 'field_notes', interest: 'interest_general', url: ''
      },
      freeze: {
        cls: '', h: 'Not sure which freeze dryer size to buy?',
        p: 'Get the free sizing checklist before you order. It walks through household size, weekly batch volume, food types, space, storage, and budget so you do not buy too small.',
        cta: 'Send Me the Checklist', source: 'harvest_right_product_page', magnet: 'home_freeze_dryer_sizing_checklist', interest: 'interest_freeze_dryers', url: PDFS.freeze
      },
      water: {
        cls: '', h: 'Not sure which water system fits your property?',
        p: 'Get the free sizing checklist before you order. It walks through water source, test results, flow needs, storage tanks, pump choices, installation space, and when to talk to us first.',
        cta: 'Send Me the Checklist', source: 'crystal_quest_ro_product_page', magnet: 'whole_house_water_system_sizing_checklist', interest: 'interest_water_systems', url: PDFS.water
      }
    }[kind];
    return '<section class="hh-capture ' + data.cls + '" data-hh-capture-block="' + kind + '">' +
      '<h2>' + data.h + '</h2><p>' + data.p + '</p>' +
      '<form data-hh-klaviyo-form="' + kind + '" data-lead-source="' + data.source + '" data-lead-magnet="' + data.magnet + '" data-interest="' + data.interest + '" data-download-url="' + data.url + '" data-auto-open="0">' +
      '<div class="hh-capture__row"><input type="email" name="email" autocomplete="email" placeholder="Email address" required><button type="submit" data-label="' + data.cta + '">' + data.cta + '</button></div>' +
      '<p class="hh-capture__fine">We will send the guide and practical Homestead Heavy emails. Unsubscribe anytime.</p><p class="hh-capture__status" aria-live="polite"></p>' +
      '</form></section>';
  }

  function injectFooter() {
    if (document.querySelector('[data-hh-capture-block="footer"]')) return;
    var footer = document.querySelector('.site-footer, footer');
    if (!footer) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = formHtml('footer');
    var target = footer.querySelector('.site-footer-blocks, .site-footer__blocks, .site-footer-wrapper') || footer;
    target.appendChild(wrap.firstElementChild);
  }

  function injectProductForms() {
    var path = window.location.pathname;
    var kind = '';
    var anchor = null;
    if (path.indexOf('/products/harvest-right-home-freeze-dryer') === 0) {
      kind = 'freeze';
      anchor = document.querySelector('[data-karr-cro-block="harvest-right-review-proof-2026-08-25"]') || document.querySelector('[data-karr-cro-block="why-buy-hh-2026-08-25"]');
    } else if (path.indexOf('/products/crystal-quest-whole-house-reverse-osmosis-system') === 0) {
      kind = 'water';
      anchor = document.querySelector('[data-karr-cro-block="cq-ro-quick-recommendation-2026-08-25"]') || document.querySelector('[data-karr-cro-block="cq-ro-review-proof-2026-08-25"]');
    }
    if (!kind || document.querySelector('[data-hh-capture-block="' + kind + '"]')) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = formHtml(kind);
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap.firstElementChild, anchor.nextSibling);
  }

  function injectExit() {
    if (document.getElementById('hh-exit-capture')) return;
    var div = document.createElement('div');
    div.id = 'hh-exit-capture';
    div.className = 'hh-exit';
    div.innerHTML = '<div class="hh-exit__panel"><button type="button" class="hh-exit__close" aria-label="Close">×</button>' + formHtml('exit') + '</div>';
    document.body.appendChild(div);
    div.querySelector('.hh-exit__close').addEventListener('click', function () { div.classList.remove('is-open'); localStorage.setItem('hh_exit_capture_closed', String(Date.now())); });
    var readyAt = Date.now() + 45000;
    function recentlyClosed() { return Number(localStorage.getItem('hh_exit_capture_closed') || 0) > Date.now() - 7 * 24 * 60 * 60 * 1000; }
    function open() { if (Date.now() >= readyAt && !recentlyClosed() && !document.querySelector('.hh-exit.is-open')) div.classList.add('is-open'); }
    document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) open(); });
    setTimeout(function () { if (window.innerWidth < 760) open(); }, 65000);
  }

  function init() {
    css();
    injectFooter();
    injectProductForms();
    injectExit();
    document.querySelectorAll('[data-hh-klaviyo-form]').forEach(bindForm);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
